import React, { useState } from "react";
import {
  ConversationContainer,
  MessagesContainer,
  MessageBubble,
  MessageContent,
  MessageTime,
  InputContainer,
  InputWrapper,
  InputField,
  InputControls,
  MagicWandIcon,
  SendButton,
} from "./ConversationChatStyle";

const ConversationChat = ({ placeholder = "Type Message" }) => {
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hi 👋 thanks for joining! Can I ask what worries you most about the future?",
      sender: "assistant",
      timestamp: "10:25",
    },
    {
      id: 2,
      text: "Climate change.",
      sender: "user",
      timestamp: "11:25",
    },
    {
      id: 3,
      text: "Got it 🌍. On a scale of 1-5, how serious of a threat do you think it is?",
      sender: "assistant",
      timestamp: "10:25",
    },
    {
      id: 4,
      text: "5",
      sender: "user",
      timestamp: "11:25",
    },
    {
      id: 5,
      text: "Thanks! And do you think the government is doing enough about it?",
      sender: "assistant",
      timestamp: "10:25",
    },
    {
      id: 6,
      text: "No",
      sender: "user",
      timestamp: "11:25",
    },
  ]);

  const [newMessage, setNewMessage] = useState("");

  const handleSend = () => {
    if (newMessage.trim()) {
      const message = {
        id: messages.length + 1,
        text: newMessage,
        sender: "user",
        timestamp: new Date().toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };
      setMessages([...messages, message]);
      setNewMessage("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <ConversationContainer>
      <MessagesContainer>
        {messages.map((message) => (
          <MessageBubble key={message.id} isUser={message.sender === "user"}>
            <MessageContent isUser={message.sender === "user"}>
              {message.text}
              <MessageTime isUser={message.sender === "user"}>
                {message.timestamp}
              </MessageTime>
            </MessageContent>
          </MessageBubble>
        ))}
      </MessagesContainer>

      <InputContainer>
        <InputWrapper>
          <InputField
            placeholder={placeholder}
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <InputControls>
            <MagicWandIcon>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.38742 3.724L0.600087 12.5127C0.239033 12.8998 0.0423816 13.412 0.0515781 13.9413C0.0607747 14.4706 0.275101 14.9757 0.649386 15.35C1.02367 15.7244 1.52868 15.9389 2.05798 15.9482C2.58728 15.9575 3.09952 15.761 3.48675 15.4L12.2761 6.61267L9.38742 3.724ZM10.3908 6.61267L8.66675 8.33667L7.66675 7.33333L9.39075 5.60933L10.3908 6.61267ZM2.54409 14.4587C2.40932 14.5871 2.23027 14.6588 2.04409 14.6588C1.8579 14.6588 1.67886 14.5871 1.54409 14.4587C1.4117 14.3259 1.33735 14.1461 1.33735 13.9587C1.33735 13.7712 1.4117 13.5914 1.54409 13.4587L6.72342 8.27867L7.72675 9.282L2.54409 14.4587ZM14.2221 9.752L16.0001 10.6413L14.2221 11.5333L13.3334 13.308L12.4448 11.5333L10.6668 10.6413L12.4448 9.752L13.3334 7.97467L14.2221 9.752ZM4.44475 3.55533L2.66675 2.66667L4.44475 1.778L5.33342 0L6.22209 1.778L8.00009 2.66667L6.22209 3.55533L5.33342 5.33333L4.44475 3.55533ZM12.8888 3.11133L11.3334 2.33333L12.8888 1.55533L13.6668 0L14.4448 1.55533L16.0001 2.33333L14.4448 3.11133L13.6668 4.66667L12.8888 3.11133Z"
                  fill="#0B4553"
                />
              </svg>
            </MagicWandIcon>
            <SendButton onClick={handleSend}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.854 0.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.382 2.111 6.636 10.07Zm.84-4.61 4.339 2.76-7.227 7.227-2.76-4.339 5.648-5.648Z"
                  fill="currentColor"
                />
              </svg>
            </SendButton>
          </InputControls>
        </InputWrapper>
      </InputContainer>
    </ConversationContainer>
  );
};

export default ConversationChat;
